import React from 'react';
import { COMPANY_INFO } from '../utils/constants';
import './LegalPages.css';

const Disclaimer: React.FC = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Disclaimer - Pickup Rental Truck Dubai",
    "description": "Disclaimer for Pickup Rental Truck Dubai. Important information about our services and limitations.",
    "url": `${COMPANY_INFO.website}/disclaimer`,
    "isPartOf": {
      "@type": "WebSite",
      "name": COMPANY_INFO.name,
      "url": COMPANY_INFO.website
    }
  };

  return (
    <div className="legal-page">
        <div className="container">
          <h1>Disclaimer</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

          <section>
            <h2>1. General Information</h2>
            <p>
              The information contained on this website and in our services is for general 
              information purposes only. While we endeavor to keep the information up to date 
              and correct, we make no representations or warranties of any kind, express or 
              implied, about the completeness, accuracy, reliability, suitability, or availability 
              with respect to the website or the information, products, services, or related 
              graphics contained on the website for any purpose.
            </p>
          </section>

          <section>
            <h2>2. Service Availability</h2>
            <p>
              {COMPANY_INFO.name} makes every effort to provide reliable pickup truck rental 
              services. However, we cannot guarantee:
            </p>
            <ul>
              <li>Uninterrupted service availability</li>
              <li>Specific vehicle availability at all times</li>
              <li>Service delivery in all weather conditions</li>
              <li>Access to all locations due to restrictions</li>
              <li>Exact timing of service delivery</li>
            </ul>
          </section>

          <section>
            <h2>3. Third-Party Content</h2>
            <p>
              Our website may contain links to third-party websites or services that are not 
              owned or controlled by {COMPANY_INFO.name}. We have no control over, and assume 
              no responsibility for, the content, privacy policies, or practices of any third-party 
              websites or services.
            </p>
          </section>

          <section>
            <h2>4. Limitation of Liability</h2>
            <p>
              In no event shall {COMPANY_INFO.name}, its directors, employees, partners, agents, 
              suppliers, or affiliates be liable for any indirect, incidental, special, consequential, 
              or punitive damages, including without limitation, loss of profits, data, use, goodwill, 
              or other intangible losses, resulting from your use of our services.
            </p>
          </section>

          <section>
            <h2>5. Professional Advice</h2>
            <p>
              The information provided on our website and through our services should not be 
              considered as professional advice. For specific transportation or logistics advice, 
              please consult with appropriate professionals.
            </p>
          </section>

          <section>
            <h2>6. Accuracy of Information</h2>
            <p>
              While we strive to provide accurate and up-to-date information, we make no 
              warranties about the accuracy, reliability, completeness, or timeliness of any 
              information on our website or provided through our services.
            </p>
          </section>

          <section>
            <h2>7. Service Modifications</h2>
            <p>
              We reserve the right to modify, suspend, or discontinue any part of our services 
              at any time without notice. We shall not be liable to you or any third party for 
              any modification, suspension, or discontinuance of our services.
            </p>
          </section>

          <section>
            <h2>8. Force Majeure</h2>
            <p>
              We shall not be liable for any failure or delay in performance under these terms 
              which is due to fire, flood, earthquake, elements of nature, or acts of God, acts 
              of war, terrorism, strikes, labor disputes, or any other cause which is beyond our 
              reasonable control.
            </p>
          </section>

          <section>
            <h2>9. Indemnification</h2>
            <p>
              You agree to defend, indemnify, and hold harmless {COMPANY_INFO.name} and its 
              licensee and licensors, and their employees, contractors, agents, officers and 
              directors, from and against any and all claims, damages, obligations, losses, 
              liabilities, costs or debt, and expenses (including but not limited to attorney's fees).
            </p>
          </section>

          <section>
            <h2>10. Governing Law</h2>
            <p>
              This disclaimer shall be governed by and construed in accordance with the laws 
              of the United Arab Emirates, without regard to its conflict of law provisions. 
              Any disputes arising from this disclaimer shall be subject to the exclusive 
              jurisdiction of the courts of Dubai, UAE.
            </p>
          </section>

          <section>
            <h2>11. Severability</h2>
            <p>
              If any provision of this disclaimer is held to be invalid or unenforceable by a 
              court, the remaining provisions of this disclaimer will remain in effect.
            </p>
          </section>

          <section>
            <h2>12. Contact Information</h2>
            <p>
              If you have any questions about this disclaimer, please contact us:
            </p>
            <div className="contact-info">
              <p><strong>Email:</strong> mkashiff6@gmail.com</p>
              <p><strong>Phone:</strong> 0543507981</p>
              <p><strong>Address:</strong> Al Quoz 4 Industrial Area, Dubai, UAE</p>
            </div>
          </section>
        </div>
      </div>
  );
};

export default Disclaimer;
